import React from 'react'

const Video = ( props ) => {
  return(
    <iframe id={ props.item.id } src={ props.item.source } style={{ ...props.item.style }} />
  )
}

export default Video